export const TrackingData = {
    PAGE: 'Power Perks',
    ACTION: 'click',
    TITLE: 'Power Perks Click',
    SUBSCRIBER_TYPE_POWER: 'power',
    SUBSCRIBER_TYPE_FREE: 'free',
    BUTTON_START_POWER_TO: 'Start Power To',
    BUTTON_REDEEM_PERK: 'Redeem Perk',
    BUTTON_COPY: 'Copy',
    BUTTON_SHOP_AT: 'Shop at',
};
